'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Vegetable Serve information
 */
var DairyServe = function (_Component) {
  (0, _inherits3.default)(DairyServe, _Component);

  function DairyServe() {
    (0, _classCallCheck3.default)(this, DairyServe);
    return (0, _possibleConstructorReturn3.default)(this, (DairyServe.__proto__ || (0, _getPrototypeOf2.default)(DairyServe)).apply(this, arguments));
  }

  (0, _createClass3.default)(DairyServe, [{
    key: 'render',
    value: function render() {
      var dairyServe = require('../Assets/dairyserve.png');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'p',
          null,
          'If your child is older than 2 years, try to choose a reduced fat dairy option',
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            'strong',
            null,
            'One serve is equivalent to:'
          )
        ),
        _react2.default.createElement(
          ReactBootstrap.Col,
          { md: 6 },
          _react2.default.createElement(
            'h5',
            null,
            'Dairy options'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                '1 cup (250mL) fresh, UHT long life, reconstituted powdered milk or buttermilk'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                '1/2 cup (120mL) evaporated milk'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                '2 slices (40g) or 4 x 3 x 2cm cube (40g) of hard cheese such as cheddar'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                '1/2 cup (120g) ricotta cheese'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                '3/4 cup (200g) yoghurt'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                '1 cup (250ml) soy, rice or other cereal drink with at least 100mg of added calcium per 100mL'
              )
            )
          )
        ),
        _react2.default.createElement(
          ReactBootstrap.Col,
          { md: 6 },
          _react2.default.createElement(
            'h5',
            null,
            'Non dairy options'
          ),
          'The following alternatives contain about the same amount of calcium as a serve of milk, yoghurt or cheese:',
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                '60g sardines (about one tin), canned in water'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                '1/2 cup (100g) canned pink salmon with bones'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                '100g firm tofu (check the label as calcium levels vary)'
              )
            )
          )
        ),
        _react2.default.createElement(
          ReactBootstrap.Col,
          { md: 12 },
          _react2.default.createElement(ReactBootstrap.Image, { src: dairyServe, responsive: true, className: 'center-block' })
        )
      );
    }
  }]);
  return DairyServe;
}(_react.Component);

exports.default = DairyServe;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ServeInformation/DairyServe/DairyServe.js
// module id = 1262
// module chunks = 0